export default __webpack_public_path__ + "static/media/tommy_media_phase2.b5da0702.mp4";